





























import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: `Flower`,
})
export default class Flower extends Vue {
  @Prop({ default: `#1d1d1b`, type: String })
  protected color!: string;
}
